import { render, staticRenderFns } from "./SystemErrorNotice.vue?vue&type=template&id=e009f738&scoped=true"
import script from "./SystemErrorNotice.vue?vue&type=script&lang=ts"
export * from "./SystemErrorNotice.vue?vue&type=script&lang=ts"
import style0 from "./SystemErrorNotice.vue?vue&type=style&index=0&id=e009f738&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e009f738",
  null
  
)

export default component.exports